const AccountingAppletPermissions = {

    sections: {

        admin: {
            key: 'admin',
            title: '{{lang}}admin',
            hasExtraHeaders: false,
            headers: {
                view: { key: 'view', title: '{{lang}}view', main: true },
                create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                self: { key: 'self', title: '{{lang}}محدود به شخص', dependancy: 'view', main: true,reverse:true },
                // block: { key: 'block', title: '{{lang}}block', dependancy: 'view', main: true },
                // terminateSessions: { key: 'terminateSessions', title: '{{lang}}terminate sessions', dependancy: 'view', main: true },
            },

            permissions: {

                forms: {
                    key: 'forms',
                    title: '{{lang}}customer form',
                    headers: {
                        view: { key: 'view', title: '{{lang}}view', main: true },
                        create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                        edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                        delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                        self: { key: 'self', title: '{{lang}}محدود به شخص', dependancy: 'view', main: true,reverse:true },

                        // block: { key: 'block', title: '{{lang}}block', dependancy: 'view', main: true },
                        // terminateSessions: { key: 'terminateSessions', title: '{{lang}}terminate sessions', dependancy: 'view', main: true },
                    }
                },

                leadsreport: {
                    key: 'leadsreport',
                    title: '{{lang}}گزارش کلی لیدها',
                    headers: {
                        view: { key: 'view', title: '{{lang}}view', main: true },
                        // create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                        // edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                        // delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                    }
                },

                leadsstatus: {
                    key: 'leadsstatus',
                    title: '{{lang}}وضعیت لیدها',
                    headers: {
                        view: { key: 'view', title: '{{lang}}view', main: true },
                        // create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                        // edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                        // delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                    }
                },

                hotleads: {
                    key: 'hotleads',
                    title: '{{lang}}میزان پیش ثبت نام قطعی',
                    headers: {
                        view: { key: 'view', title: '{{lang}}view', main: true },
                        // create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                        // edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                        // delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                    }
                },



                permissions: {

                    key: 'permissions',
                    title: 'دسترسی‌های شعبه',
                    headers: {
                        view: { key: 'view', title: '{{lang}}view', main: true },
                        create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                        edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                        delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                    }
                },


            }
        },

        settings: {
            key: 'settings',
            title: '{{lang}}settings',
            hasExtraHeaders: false,
            headers: {
                view: { key: 'view', title: '{{lang}}view', main: true },
                create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                // block: { key: 'block', title: '{{lang}}block', dependancy: 'view', main: true },
                // terminateSessions: { key: 'terminateSessions', title: '{{lang}}terminate sessions', dependancy: 'view', main: true },
            },

            permissions: {


                users: {
                    key: 'users',
                    title: '{{lang}}Users management',
                    headers: {
                        view: { key: 'view', title: '{{lang}}view', main: true },
                        create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                        edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                        delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                    }
                },


                permissions: {

                    key: 'permissions',
                    title: '{{lang}}permissions',
                    headers: {
                        view: { key: 'view', title: '{{lang}}view', main: true },
                        create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                        edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                        delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                    }
                },


                branches: {
                    key: 'branches',
                    title: '{{lang}}Branches management',
                    headers: {
                        view: { key: 'view', title: '{{lang}}view', main: true },
                        create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                        edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                        delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                    }
                },


                colors: {
                    key: 'colors',
                    title: '{{lang}}مدیریت رنگ‌ها',
                    headers: {
                        view: { key: 'view', title: '{{lang}}view', main: true },
                        create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                        edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                        delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                    }
                },


                cars: {
                    key: 'cars',
                    title: '{{lang}}مدیریت خودروها',
                    headers: {
                        view: { key: 'view', title: '{{lang}}view', main: true },
                        create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                        edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                        delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                    }
                },


                // adminLogs: {
                //     key: 'adminLogs',
                //     title: '{{lang}}Admin Logs',
                //     headers: {
                //         view: { key: 'view', title: '{{lang}}view', main: true },
                //     }
                // },

                // settings: {
                //     key: 'settings',
                //     title: '{{lang}}settings',
                //     headers: {
                //         view: { key: 'view', title: '{{lang}}view', main: true },
                //         create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
                //         edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
                //         delete: { key: 'delete', title: '{{lang}}delete', dependancy: 'view', main: true },
                //     }
                // },
            }
        }

    }

}


export { AccountingAppletPermissions }